import {
  createSlice, PayloadAction,
} from '@reduxjs/toolkit';

export const RtcGlobalsSlice = createSlice({
  name: 'rtcGlobal',
  initialState: {
    waitingTimeLeft: 0,
    alert: '',
    timer: null,
  },
  reducers: {
    setWaitingTimeLeft(state, action: PayloadAction<number>) {
      state.waitingTimeLeft = action.payload;
    },
    setRtcAlert(state, action: PayloadAction<string>) {
      state.alert = action.payload;
    },
    setRtcTimer(state, action: PayloadAction<number>) {
      state.timer = action.payload;
    },
    decrementWaitingTime(state) {
      if (state.waitingTimeLeft > 0) state.waitingTimeLeft -= 1000;
      else clearInterval(state.timer);
    },
    resetTimer(state) {
      if (state.timer) clearInterval(state.timer);
      state.timer = null;
      state.waitingTimeLeft = 0;
    },
  },
});

export const selectRtcWaitingTimeLeft = (state: any) => state.rtcGlobals.waitingTimeLeft;
export const selectRtcAlert = (state: any) => state.rtcGlobals.alert;
export const selectRtcTimer = (state: any) => state.rtcGlobals.timer;

export const {
  setWaitingTimeLeft,
  setRtcAlert,
  setRtcTimer,
  decrementWaitingTime,
  resetTimer,
} = RtcGlobalsSlice.actions;

export default RtcGlobalsSlice.reducer;
